import React, { useEffect } from 'react';
import { call } from '../../functions';

interface LifecycleProps {
    children?: any;
    component?: any;
    onMount?: () => void;
    onUnmount?: () => void;
}

export const Lifecycle = (props: LifecycleProps) => {
    const {
        onMount,
        onUnmount,
        children,
        component: Component,

        ...rest
    } = props;

    useEffect(() => {
        call(onMount);
        return () => {
            call(onUnmount);
        };
    }, ['']);

    if (Component) {
        return <Component {...rest} />;
    }

    return children;
};

Lifecycle.displayName = 'Lifecycle';
